import { TouchableOpacity, View } from 'react-native'
import React, { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'
import { BtApiTable, BtText } from '@linqpal/components/src/ui'

import { routes2 } from '@linqpal/models'
import { useNavigation } from '@react-navigation/native'
import { useSearchInput } from '../../../../../utils/hooks'
import { SearchField } from '../ProjectsTable/SearchField'
import { ProjectsEmptyContent } from '../ProjectsEmptyContent'
import { paths } from '../../../../links'
import projectsStore from '../../../Store'
import { customStyles } from './customStyles'
import { styles } from './styles'
import { useResponsive } from '@linqpal/components/src/hooks'

type Props = {
  cols?: any
  params?: any
}

export const ProjectsTable: React.FC<Props> = observer(({ cols, params }) => {
  const navigation = useNavigation()
  const { sm } = useResponsive()
  const { t } = useTranslation('global')
  const { searchText, setSearchText } = useSearchInput()
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false)
  const { count, pageSize, refresher, updateProjectDetail } = projectsStore

  const getAddress = ({ streetAddress, city, state, zip }) => {
    return `${streetAddress}, ${city}, ${state}, ${zip}`
  }

  const col = [
    {
      cell: (item: any) => (
        <View
          style={{
            flexDirection: 'row',
            marginBottom: 20,
            marginTop: 20,
            width: '100%',
          }}
        >
          <View style={{ flex: 1 }}>
            <BtText style={styles.rowsLabel}>
              {item.data
                ? getAddress(item.data?.propertyAddress.items[0].content)
                : item.address}
            </BtText>
          </View>
          <TouchableOpacity
            style={{
              width: 126,
              height: 34,
              borderRadius: 8,
              backgroundColor: '#F5F7F8',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            onPress={() => {
              updateProjectDetail(item)
              navigation.navigate(paths.Console.Projects.Details, {
                projectId: item?._id,
              })
            }}
          >
            <BtText style={{ fontWeight: '700', fontSize: 14 }}>
              {t('Projects.more-details')}
            </BtText>
          </TouchableOpacity>
        </View>
      ),
    },
  ]
  return (
    <View style={styles.mainWrapper}>
      <BtApiTable
        style={customStyles}
        columns={cols || col}
        apiCaller={(args) => routes2.project.findAll(args)}
        filterPlaceholder={t('Projects.searchPropertyAddress' as any)}
        defaultSortColumn={t('Projects.createdAt' as any)}
        refresher={refresher}
        noDataComponent={
          <ProjectsEmptyContent
            title={t('noItems')}
            subtitle={t('Projects.TryAgainProject')}
            btnText={t('Projects.create-project')}
          />
        }
        pagination
        paginationServer
        rowsPerPage={pageSize}
        paginationTotalRows={count}
        paginationPerPage={5}
        onItemPress={(item: { _id: string }) => {
          updateProjectDetail(item)
          navigation.navigate(paths.Console.Projects.Details, {
            projectId: item?._id,
          })
        }}
        filterWidth={sm ? 680 : '100%'}
        subHeader
        subHeaderAlign={t('Projects.left' as any)}
        highlightOnHover={false}
        subHeaderComponent={
          <SearchField
            value={searchText}
            onChange={setSearchText}
            setResetPaginationToggle={setResetPaginationToggle}
            resetPaginationToggle={resetPaginationToggle}
          />
        }
        extraApiParams={{ invoices: params }}
      />
    </View>
  )
})
